import { Component, Inject } from '@angular/core';
import { ResetReviewService } from '../../services/raintree/Transmission/reset-review.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DpSuccessMessageComponent } from '../../common-component/dp-success-message/dp-success-message.component';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-reset-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatIconModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
  ],
  templateUrl: './reset-dialog.component.html',
  styleUrl: './reset-dialog.component.scss'
})
export class ResetDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public memkey: any,
    private resetService: ResetReviewService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private toaster: ToastrService,
    private dialogRef: MatDialogRef<ResetDialogComponent>
  ) {}
  queryParams: any = { ...this.route.snapshot.queryParams };

  resetDatum() {
    let bodyObj = {
      uiState: this.queryParams['state'],
    };
    console.log(bodyObj);
    this.resetService.resetMemdata(this.memkey,bodyObj).subscribe({
      next: (response) => {
        this.dialog.open(DpSuccessMessageComponent, {
          panelClass: 'common-pannel-dialog-container',
          data: {
            mainHeading: response.message,
            subHeading: '',
            buttonValue: 'Done',
            reload: true,
          },
        });
        this.dialogRef.close(true);
      },
      error: (error) => {
        console.log(error);
        this.toaster.error(error);
        this.dialogRef.close(true);
      },
    });
  }
}
